import { DocumentNode, gql } from '@apollo/client';
import * as React from 'react';

import { Sentinel } from '@/components/Sentinel';

import { Announcement_AnnouncementFragment } from './graphql-types/Announcement_AnnouncementFragment';

import { Blog } from './components/Blog';
import { EventAlert } from './components/EventAlert';
import { Poll } from './components/Poll';
import { Question } from './components/Question';
import { SimplePost } from './components/SimplePost';

export const Announcement: React.FC<{
  announcement: Announcement_AnnouncementFragment;
  isSecondToLast: boolean;
  loadMore: () => void;
  hasMore: boolean;
}> & {
  announcementsFragment: DocumentNode;
} = ({ announcement, isSecondToLast, loadMore, hasMore }) => {
  const { postV2 } = announcement;
  if (!postV2) {
    return null;
  }
  return postV2.__typename === 'SimplePost' ? (
    <SimplePost key={postV2._id} simplePost={postV2} m="1">
      {isSecondToLast && hasMore && <Sentinel onIntersection={loadMore} />}
    </SimplePost>
  ) : postV2.__typename === 'PollV2' ? (
    <Poll key={postV2._id} poll={postV2} m="1">
      {isSecondToLast && hasMore && <Sentinel onIntersection={loadMore} />}
    </Poll>
  ) : postV2.__typename === 'QuestionV2' ? (
    <Question key={postV2._id} question={postV2} m="1">
      {isSecondToLast && hasMore && <Sentinel onIntersection={loadMore} />}
    </Question>
  ) : postV2.__typename === 'EventAlert' ? (
    <EventAlert key={postV2._id} eventAlert={postV2} m="1">
      {isSecondToLast && hasMore && <Sentinel onIntersection={loadMore} />}
    </EventAlert>
  ) : postV2.__typename === 'BlogV2' ? (
    <Blog key={postV2._id} blog={postV2} m="1">
      {isSecondToLast && hasMore && <Sentinel onIntersection={loadMore} />}
    </Blog>
  ) : null;
};

Announcement.announcementsFragment = gql`
  fragment Announcement_AnnouncementFragment on Announcement {
    _id
    currentUserShouldSeeAsUnread
    postV2 {
      _id
      ... on SimplePost {
        _id
        ...SimplePostAnnouncement_SimplePostFragment
      }
      ... on QuestionV2 {
        _id
        ...QuestionAnnouncement_QuestionFragment
      }
      ... on PollV2 {
        _id
        ...PollAnnouncement_PollFragment
      }
      ... on EventAlert {
        _id
        ...EventAlertAnnouncement_EventAlertFragment
      }
      ... on BlogV2 {
        ...BlogAnnouncement_BlogFragment
      }
    }
  }
  ${SimplePost.simplePostFragment}
  ${Question.questionFragment}
  ${Poll.pollFragment}
  ${EventAlert.eventAlertFragment}
  ${Blog.blogFragment}
`;
